<svg [lucideIcon]="icon()" [size]="resolvedSize()" [strokeWidth]="strokeWidth()" [attr.fill]="fill()"></svg>
